import styled from 'styled-components';

export const Container = styled.div`
  &.FaqWrapper{
    margin-top: 70px;
    margin-bottom: 165px;
  }
`;

export const StyledH2 = styled.h2`
  font-family: Manrope, Helvetica, "Helvetica Neue", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  line-height: 135%;
  color: #2C2B48;
`;